module.exports = __webpack_public_path__ + "img/art-bg-carousel-container.a55f3e7.png";